// removed by extract-text-webpack-plugin
module.exports = {"address":"PDLqVVHPFu7P9CW8-oUrw"};


//////////////////
// WEBPACK FOOTER
// ./shared/components/AddressBook/components/SelectedAddress/styles.scss
// module id = 926
// module chunks = 0